import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FEATURE_TOGGLE_ASK, TSDIGITAL_PORTALE_PUBLIC_URL } from "../../config";
import { FormattedMessage } from "react-intl";
import WidgetCommercialistaDeadlines from "../deadlines/widgetCommercialista";
import WidgetTotalCustomer from "../widget/widgetTotalCustomer";
import WidgetCrisisCompanies from "../widget/widgetCrisisCompanies";
import WidgetRatingCompanies from "../widget/widgetRatingCompanies";
import "./style.css";
import WidgetAsk from "../ask/widgets/widgetCommercialista";
import { usePermissions } from "../../customHooks";
import { getCrisisCompanies } from "../../store/actions/rating";
import { Button } from "@ts-digital/vrc";
import { useNavigate } from "react-router-dom";

const DashCommercialista = props => {
  const {
    accountantSelected,
    accountantIdSelected,
    accountantUuidSelected,
    clientIdSelected,    
    companyUuidSelected
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const studio = useSelector(state => state.studio);
  const company = useSelector(state => state.company);
  const main = useSelector(state => state.main);
  const user = useSelector(state => state.user);
  const deadlinesSubjectiveV2 = useSelector(state => state.deadlinesSubjectiveV2);
  const surveys = useSelector(state => state.ask.surveys);
  const currentPermissions = useSelector(state => state.currentPermissions);
  const services = useSelector(state => state.servicesAgyo);

  let studioFind;

  if (main?.accountantUuidSelected) {
    studioFind = studio?.list?.find((x) => x.uuid === main?.accountantUuidSelected) ||
    company?.companies?.find(x => x?.uuid === main?.companyUuidSelected)?.commercialistiList?.find(x => x?.uuid === main?.accountantUuidSelected);
  }

  const showBanner = localStorage.getItem("showCheckupBanner");
  const [visibleBanner, setVisibleBanner] = useState(showBanner === "true" || showBanner === "null" || showBanner === null);

  useEffect(() => {
    dispatch(getCrisisCompanies(auth, accountantSelected));
    if (window.aptrinsic) {
      let name = "";
      if (user && user.profile) {
        name = `${user.profile.firstName} ${user.profile.lastName}`;
      }
      window.aptrinsic("track", "digital-box:HOME-ACCOUNTANT");
      window.aptrinsic("track", "digital-box:SCHEDA-CLIENTE");
      window.aptrinsic(
        "track", "digital-box:SURVEY-ACCOUNTANT-1", {
          Nome: name
        }
      );
    }
  },
  []);

  const goToOtherDeadlinesSubjective = () => {
    navigate("/scadenze");
  };

  const goToOtherAskSurveys = () => {
    navigate("/ask-list");
  };

  const { isPermissionAsk } = usePermissions(currentPermissions);

  let allAccountantServices = {};
  let accountantHasCheckupImpresa = false;
  if (
    !services?.allAccountantServices.status.started &&
    services?.allAccountantServices.status.ended &&
    services?.allAccountantServices?.status?.list
  ) {
    allAccountantServices = services?.allAccountantServices.status.list;
  }
  for (let service in allAccountantServices){
    if (allAccountantServices[service] && (allAccountantServices[service].id === "MODE-CRAM")){
      accountantHasCheckupImpresa = true;
    }
  }

  return (
    <div>
      <div className="dashboardWrapper">
        {/* Renderizzo il widget se e solo se ho il set di prop minime a far scattare
          * il componenteDidMount diversamente ci possono essere problemi di chiamate non
          * fatte o chiamate doppie
          */
          /** TODO FIX DASH */
          auth && accountantSelected && studioFind?.taxRegion !== "ES" ? (
            <WidgetCommercialistaDeadlines
              accountantSelected={accountantSelected}
              accountantIdSelected={accountantIdSelected}
              accountantUuidSelected={accountantUuidSelected}
              auth={auth}
              deadlinesSubjectiveV2={deadlinesSubjectiveV2}
              goToOtherDeadlinesSubjective={goToOtherDeadlinesSubjective}              
              isDoubleBox={false}
              numberItems={4}
            />
          ) : null}
        {auth && accountantIdSelected && clientIdSelected && (
          <WidgetTotalCustomer />
        )}

        {/* Renderizzo il widget se e solo se ho il set di prop minime a far scattare
          * il componenteDidMount diversamente ci possono essere problemi di chiamate non
          * fatte o chiamate doppie
          */
          /** TODO FIX DASH */
          auth &&
            accountantSelected &&
            FEATURE_TOGGLE_ASK === "true" &&
            isPermissionAsk ? (
              <WidgetAsk
                accountantSelected={accountantSelected}
                accountantIdSelected={accountantIdSelected}
                auth={auth}
                company={company}
                surveys={surveys}
                goToOtherAskSurveys={goToOtherAskSurveys}                
                isDoubleBox={false}
                numberItems={4}
              />
            ) : null}
      </div>

      {accountantHasCheckupImpresa && (
        <div className="dashboardWrapper">
          <WidgetRatingCompanies />
          <WidgetCrisisCompanies
            accountantIdSelected={accountantIdSelected}
            accountantUuidSelected={accountantUuidSelected}
            clientIdSelected={clientIdSelected}            
            company={company}
            companyUuidSelected={companyUuidSelected}
          />
        </div>
      )}
      {!accountantHasCheckupImpresa && visibleBanner && studioFind?.taxRegion !== "ES" && (<div className='accountantBanner'>
        <div className='accountantBannerText'>
          <b>Check Up d'Impresa</b>, <FormattedMessage id="checkup.accountantBanner" />
        </div>
        <div style={{float:"right", display:"flex"}}>
          <div style={{marginRight:"20px"}}>
            <Button
              onClick={() => {
                localStorage.setItem("showCheckupBanner", false);
                setVisibleBanner(false);
              }}
              className="buttonNoDisplay"
              kind="secondary" colorScheme={"ghost"}><FormattedMessage id="dashboard.noDisplay" /></Button>
          </div>
          <div onClick={() => {
            if (window.aptrinsic) {     
              window.aptrinsic("track", "digital-box:CHECKUP-SHOW-MORE");
            }
          }} style={{marginRight:"60px"}}>
            <a href={
              TSDIGITAL_PORTALE_PUBLIC_URL + "#/" + accountantIdSelected + "/apps/creditrisk/details"
            }
            id="goToTSDigital"
            target="_blank"
            rel="noopener noreferrer"><Button colorScheme={"ghost"} kind="primary"><FormattedMessage id="dashboard.showMore" /></Button></a>
          </div>
        </div>
      </div>)}
    </div>
  );
};

export default DashCommercialista;
